@if(dialog$ | async; as dialog) {
    <div class="modal-header modal-header--import flex-column">
        <div class="modal-title">Import - Volunteers</div>
        @if (step === 'import') {
            <div class="modal-subtitle mt-2">Import Volunteers from an excel file (Download 
                <a (click)="downloadExcelTemplate()" class="template">template</a>) 
                <a class="template" (click)="onToggleReadMore()">{{readmore ? 'hide more': 'read more'}}</a>
            </div>
        } 
        @else if (step === 'review') {
            <div class="d-flex align-items-center modal-subtitle body-2 mt-2">
                <span class="green-text mr-1"><b>{{validEmails}}</b></span> valid,
                <span class="red-text ml-2 mr-1"><b>{{invalidEmails}}</b></span> errors
            </div>
        }
        <button type="button" class="cursor-pointer" class="close close--paybee position-absolute" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
            <span class="cursor-pointer" aria-hidden="true">×</span>
        </button>
        @if(readmore) {
            <div class="readmore mt-2">
                <div class="mb-3">Support File Format: Excel with header row</div>
                <div>
                    <div class="headline-7--temporary mb-2">Volunteers Sheet</div>
                    <div class="modal-subtitle mb-2">Fill for all Volunteers</div>
                    <table width="750" border="2" cellpadding="5">
                        <thead>
                            <tr>
                                <td><b>Column Name</b></td>
                                <td><b>Required</b></td>
                                <td><b>Description</b></td>
                                <td><b>Note</b></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Email</td>
                                <td>required</td>
                                <td>Email</td>
                                <td>Full Email </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        }
    </div>

    @switch (step) {
        @case ('import') {
            <div class="modal-body">
                <app-volunteers-import-xlsx
                    [import]="import"
                    [existingVolunteerList]="volunteersImportService.existingVolunteerList"
                    (onChange)="onChangeData($event)"
                ></app-volunteers-import-xlsx>
            </div>
        }
        @case ('review') {
            <div style="height: 300px; overflow-y: auto;">
                <table class="import-list-table">
                    <thead>
                        <tr>
                            <th class="body-3 pl-5" style="max-width: 260px;">Email</th>
                            <th class="body-3" style="min-width: 70px;">Status</th>
                        </tr>
                    </thead>
                    <tbody>
    
                    @for (volunteer of volunteersImportService.volunteerList; track volunteer; let idx = $index) {
                        <tr>                
                            <td class="d-flex align-items-center pl-2" >
                                <div class="statusIcon mx-3 headline-6"
                                    [innerHTML]="volunteer.statusIcon ? volunteer.statusIcon : idx + 1" 
                                    [ngStyle]="{color: volunteer.statusIcon ? '' : '#25C157'}">
                                </div>
                                <div class="d-flex flex-column">
                                    <span [innerHTML]="volunteer.email" class="body-2"></span>
                                </div>
                            </td>
                            
                            <td class="position-relative">
                                <div class="d-flex flex-column">
                                    <div [innerHTML]="volunteer.statusText"></div>
                                    <div [innerHTML]="volunteer.statusMessage"></div>
                                </div>
                            </td>
                        </tr>
                    }
                    @empty {
                        <tr>
                            <td colspan="2" class="text-center py-3 body-2">
                                No Volunteers Found
                            </td>
                        </tr>
                    }
    
                    </tbody>
                </table>
            </div>
        }
        @case ('completed') {
            <div class="d-flex justify-content-center align-items-center flex-column" style="height: 300px;">
                <div class="resultIcon mb-2" [innerHTML]="finalIcon"></div>
                <span class="headline-6 mb-1">Upload Completed</span>
                <span class="body-1"><span class="green-text font-weight-bold">{{volunteersImportService.successfulCount}}</span> Volunteer(s) Successfully Added.</span>
                <span class="body-1"><span class="red-text font-weight-bold">{{volunteersImportService.failedCount}}</span> Volunteer(s) Failed to Add.</span>
            </div>
        }
    }


    <div class="modal-footer modal-footer--import">
        @switch (step) {
            @case ('review') {
                <div class="d-flex align-items-center justify-content-between w-100">
                    <button (click)="onBackClick()"
                        type="button" class="btn modal-outline-button btn-sm">
                        Back
                    </button>

                    <button (click)="onUpload()" [disabled]="disableUpload"
                        type="button" class="btn btn--paybee btn--black btn--md text-center">
                        Add ({{validEmails}})
                    </button>
                </div>
            }
            @case ('completed') {
                <div class="d-flex justify-content-end w-100">
                    <button (click)="onClose(dialog)" 
                        type="button" class="btn btn-sm modal-success-button waves-effect waves-light">
                        Done
                    </button>
                </div>
            }
        }
    </div>
}
